import { SxProps } from '@mui/material'

import theme from '../../../../../../shared/styles/themes/default.theme'

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  } as SxProps,

  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  } as SxProps,

  filterControl: {
    display: 'flex',
    alignItems: 'center'
  } as SxProps,

  bankSection: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[200]}`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    boxShadow: '0px 25px 60px rgba(15, 23, 42, 0.06)',
    gap: theme.spacing(3)
  } as SxProps,

  bankSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  } as SxProps,

  externalBankIdChip: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[500],
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: '0.7rem',
    letterSpacing: '0.5px',
    height: 24
  } as SxProps,

  bankHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2)
  } as SxProps,

  loadingGrid: {
    marginTop: theme.spacing(1)
  } as SxProps
}

export default styles
